import { render, staticRenderFns } from "./TableComparativePreviousTournaments.vue?vue&type=template&id=1cc9d251&scoped=true&"
import script from "./TableComparativePreviousTournaments.vue?vue&type=script&lang=js&"
export * from "./TableComparativePreviousTournaments.vue?vue&type=script&lang=js&"
import style0 from "./TableComparativePreviousTournaments.vue?vue&type=style&index=0&id=1cc9d251&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc9d251",
  null
  
)

export default component.exports